import BaseViewport from '@/common/components/templates/baseViewport/BaseViewport.vue';
import { VIEWPORT_TYPE } from '@/common/components/templates/baseViewport/baseViewport.define';
import { RouteRecordRaw } from 'vue-router';
import { requireAuth, setDayjsTimezone } from '@/common/router/authGuard';
import { extractAccessibleRoutes } from '@/common/auth/auth.utils';
import { ROLE_PERMISSION_KEY } from '@/common/define/rolePermission.define';

const PREFIX_ANALYSIS = 'analysis_';

/**
 * 챗봇 generate_report 결과를 보여주는 풀스크린 라우트.
 * - /analysis/reports          : 현재 세션 리포트 list (chatStore.chatMessages 필터)
 * - /analysis/reports/:reportId: 단일 리포트 상세 (ReportRenderer)
 *
 * 챗봇 진입점(런처·GNB)과 동일한 MONITORING_AI_ASSISTANT 권한으로 가드한다.
 * 리포트는 챗봇 산출물이라 런처만 숨기면 URL 직접 입력으로 우회 진입이 가능했다.
 */
const analysisMenu: RouteRecordRaw[] = [
  {
    path: '/analysis/',
    name: `${PREFIX_ANALYSIS}Analysis`,
    component: BaseViewport,
    beforeEnter: [requireAuth, setDayjsTimezone],
    meta: {
      rolePermission: ROLE_PERMISSION_KEY.MONITORING.MONITORING_AI_ASSISTANT,
      viewport: VIEWPORT_TYPE.REALTIME,
    },
    redirect: '/analysis/reports',
    children: [
      {
        path: 'reports',
        name: 'AnalysisReportList',
        component: () => import('../views/ReportListView.vue'),
        meta: {
          viewport: VIEWPORT_TYPE.REALTIME,
        },
      },
      {
        path: 'reports/:reportId',
        name: 'AnalysisReportDetail',
        component: () => import('../views/ReportDetailView.vue'),
        meta: {
          viewport: VIEWPORT_TYPE.REALTIME,
        },
      },
    ],
  },
];

const getAnalysisNaviMenu = () => {
  return extractAccessibleRoutes(analysisMenu);
};

export { analysisMenu, getAnalysisNaviMenu };
